import "../../commentList.scss";

// Texte d'un commentaire : contenu HTML produit par l'éditeur (mentions @).
const CommentNameView = ({ comment }) => (
  <div className="cl-texte ck-content" dangerouslySetInnerHTML={{ __html: comment.text }} />
);

export default CommentNameView;
